//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "Youtube",
    props: ['video_id', 'content'],

    player: null,

    mounted: function mounted() {
        var _this = this;

        if (document.getElementById('youtube-iframe-api')) {
            // Wenn eine zweite Instanz dieser Komponente erstellt wird, dann ist die API schon bereit
            this.spawnPlayer();
        } else {
            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.id = "youtube-iframe-api";
                script.async = true;
                script.src = "https://www.youtube.com/iframe_api";
                script.onload = function () {
                    window.onYouTubeIframeAPIReady = function () {
                        _this.spawnPlayer();
                        resolve();
                    };
                };
                document.body.appendChild(script);
            });
        }
    },


    methods: {
        spawnPlayer: function spawnPlayer() {
            this.player = new YT.Player('youtube-video', {
                videoId: this.video_id,
                playerVars: {
                    'modestbranding': 1,
                    'autoplay': 1,
                    'controls': 1
                },
                events: {
                    'onReady': function onReady() {},
                    'onStateChange': function onStateChange(event) {
                        if (event.data === YT.PlayerState.ENDED) {}
                    }
                }
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/js/components/player/page/Youtube.vue
// module id = 62
// module chunks = 0